




































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
  get logoALText(): string {
    return require("../assets/icons/AuthenticLabs.svg");
  }
  get facebookImage(): string {
    return require("../assets/images/facebook-filled.png");
  }
  get instagramImage(): string {
    return require("../assets/images/instagram-filled.png");
  }
  get twitterImage(): string {
    return require("../assets/images/twitter-circle-filled.png");
  }
  get linkedInImage(): string {
    return require("../assets/images/linkedin-filled.png");
  }
  get upArrowIcon() {
    return require("@/assets/icons/ArrowUpRight.svg");
  }
}
